import * as React from "react";
import { TextBox } from "../../atoms/forms/TextBox";
import { ThemaIcon } from "../../atoms/icons/ThemaIcon";
import { ICommonInputsControls } from "./ICommonInputsControls";
import { useTranslation } from 'react-i18next';


// All the incoming values
interface IProps {

}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & ICommonInputsControls<string>;
export const ThemaTextBox = (props: AllProps) => {
    const { t: tDatatypes } = useTranslation('datatypes');

    const label = props.label || tDatatypes('themaLabel') || "Thema";
    const placeholder = props.placeholder || tDatatypes('themaPlaceholder') || "Thema";
    return (<TextBox
            {...props}
            label={label}
            icon={<ThemaIcon />}
            placeholder={placeholder}
         />)
}
